// extracted by mini-css-extract-plugin
module.exports = {"buttonElement":"style_buttonElement__ZFmxO","buttonIcon":"style_buttonIcon__A6FbC"};